type RenderableUser = { firstName?: string; lastName?: string };

export const getFullName = (person: RenderableUser | undefined | null) => {
  if (person === null || typeof person === 'undefined') {
    return '';
  }
  return [person?.firstName, person?.lastName].filter(Boolean).join(' ');
};
